export class UploadSource {
    public id: number;
    public description: string | null;
    public name: string;
    public logo: string | null;
    public logoStyle: string | null;
    public telephone: string | null;
    public email: string | null;
    public sizeLimitInGb: number;

    constructor(
        id: number,
        description: string | null,
        name: string,
        logo: string | null,
        logoStyle: string | null,
        telephone: string | null,
        email: string | null,
        sizeLimitInGb: number,
    ) {
        this.id = id;
        this.description = description;
        this.name = name;
        this.logo = logo;
        this.logoStyle = logoStyle;
        this.telephone = telephone;
        this.email = email;
        this.sizeLimitInGb = sizeLimitInGb;
    }
}
